(() => {
  if (customElements.get('lp-social-proof-slider')) return;

  const MOBILE_MEDIA_QUERY = '(max-width: 767px)';
  const SLIDE_OFFSET_AFTER = 20;

  class LpSocialProofSlider extends HTMLElement {
    constructor() {
      super();
      this.onMediaChange = this.onMediaChange.bind(this);
      this.onSectionLoad = this.onSectionLoad.bind(this);
      this.onWindowLoad = this.onWindowLoad.bind(this);
      this.swiper = null;
      this.mediaQuery = window.matchMedia(MOBILE_MEDIA_QUERY);
    }

    connectedCallback() {
      this.sliderEl = this.querySelector('[data-slider]');

      if (!this.sliderEl) return;

      this.classList.remove('is-initialized');
      this.mediaQuery.addEventListener('change', this.onMediaChange);

      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        document.addEventListener('shopify:section:load', this.onSectionLoad);
      }

      if (typeof Swiper === 'undefined') {
        window.addEventListener('load', this.onWindowLoad, { once: true });
        return;
      }

      this.onMediaChange();
    }

    disconnectedCallback() {
      this.mediaQuery.removeEventListener('change', this.onMediaChange);

      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        document.removeEventListener('shopify:section:load', this.onSectionLoad);
      }

      window.removeEventListener('load', this.onWindowLoad);
      this.destroySwiper();
    }

    onWindowLoad() {
      this.onMediaChange();
    }

    onSectionLoad(event) {
      if (!event.target.contains(this)) return;
      this.destroySwiper();
      this.onMediaChange();
    }

    onMediaChange() {
      if (this.mediaQuery.matches) {
        this.initSwiper();
        return;
      }

      this.destroySwiper();
    }

    initSwiper() {
      if (typeof Swiper === 'undefined' || this.swiper || !this.mediaQuery.matches) {
        return;
      }

      const slideCount = this.sliderEl.querySelectorAll('.swiper-slide').length;
      if (!slideCount) return;

      this.swiper = new Swiper(this.sliderEl, {
        slidesPerView: 1.8,
        spaceBetween: 20,
        slidesOffsetAfter: SLIDE_OFFSET_AFTER,
        allowTouchMove: true,
        breakpoints: {
          599: {
            slidesPerView: 1.4395,
            spaceBetween: 20,
            slidesOffsetAfter: SLIDE_OFFSET_AFTER
          }
        },
        on: {
          init: () => {
            requestAnimationFrame(() => {
              this.classList.add('is-initialized');
            });
          }
        }
      });
    }

    destroySwiper() {
      if (!this.swiper) return;

      this.swiper.destroy(true, true);
      this.swiper = null;
      this.classList.remove('is-initialized');
    }
  }

  customElements.define('lp-social-proof-slider', LpSocialProofSlider);
})();
